export default {
	methods: {
		setCurrencyToUSD() {
			var newCurrency = {}
			this.allExchanges.find(function (currency) {
				if (currency.currency.toLowerCase() === 'usd') {
					newCurrency = currency
				}
			})
			this.$store.commit('LOCAL_CURRENCY2', newCurrency)
		},
		setCurrencyToKES() {
			var newCurrency = {}
			this.allExchanges.find(function (currency) {
				if (currency.currency.toLowerCase() === 'kes') {
					newCurrency = currency
				}
			})
			this.$store.commit('LOCAL_CURRENCY2', newCurrency)
		},
		convert1: function (currencyToConvertFrom, amountToConvert) {
			if (currencyToConvertFrom === undefined || amountToConvert === undefined) {
				return {
					amount: 0,
					raw_amount: 0,
					sign: ''
				}
			}
			if (currencyToConvertFrom === undefined) {
				currencyToConvertFrom = 'KES'
			}
			if (amountToConvert === undefined) {
				amountToConvert = 0
			}
			var currencyToConvertTo = this.$store.state.CurrencyStore.browser_currency.toLowerCase()
			var allExchanges = this.$store.state.CurrencyStore.exchanges
			currencyToConvertFrom = currencyToConvertFrom.toLowerCase()
			var sign = ''
			if (currencyToConvertFrom === currencyToConvertTo) {
				if (currencyToConvertFrom === 'kes') {
					sign = 'KES'
				} else {
					allExchanges.find(function (currency) {
						if (currency.currency.toLowerCase() === currencyToConvertTo) {
							sign = currency.sign
						}
					})
				}
				return {
					amount: amountToConvert,
					raw_amount: amountToConvert,
					sign: sign
				}
			} else if (currencyToConvertFrom === 'kes') {
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertTo) {
						amountToConvert = Number(amountToConvert) / Number(currency.buy_amount)
						sign = currency.sign
					}
				})
				return {
					amount: amountToConvert,
					raw_amount: amountToConvert,
					sign: sign
				}
			} else if (currencyToConvertTo === 'kes') {
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertFrom) {
						amountToConvert = Number(amountToConvert) * Number(currency.sell_amount)
					}
				})
				return {
					amount: amountToConvert,
					raw_amount: amountToConvert,
					sign: 'KES'
				}
			} else if (currencyToConvertFrom !== currencyToConvertTo && currencyToConvertFrom !== 'kes' && currencyToConvertTo !== 'kes') {
				var amount = 0
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertFrom) {
						amount = Number(amountToConvert) * Number(currency.buy_amount)
					}
				})
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertTo) {
						amount = Number(amount) / Number(currency.sell_amount)
						sign = currency.sign
					}
				})
				return {
					amount: amount,
					raw_amount: amount,
					sign: sign
				}
			}
		},
		convert2: function (currencyToConvertFrom, currencyToConvertTo, amountToConvert) {
			if (currencyToConvertFrom === undefined) {
				currencyToConvertFrom = 'KES'
			}
			if (currencyToConvertTo === undefined) {
				currencyToConvertFrom = 'KES'
			}
			currencyToConvertFrom = currencyToConvertFrom.toLowerCase()
			currencyToConvertTo = currencyToConvertTo.toLowerCase()
			var sign = ''
			var allExchanges = this.$store.state.CurrencyStore.exchanges
			if (currencyToConvertFrom === currencyToConvertTo) {
				if (currencyToConvertFrom === 'kes') {
					sign = 'KES'
				} else {
					allExchanges.find(function (currency) {
						if (currency.currency.toLowerCase() === currencyToConvertTo) {
							sign = currency.sign
						}
					})
				}
				return {
					amount: Math.round(amountToConvert),
					raw_amount: amountToConvert,
					sign: sign
				}
			} else if (currencyToConvertFrom === 'kes') {
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertTo) {
						amountToConvert = Number(amountToConvert) / Number(currency.buy_amount)
						sign = currency.sign
					}
				})
				return {
					amount: Math.round(amountToConvert),
					raw_amount: amountToConvert,
					sign: sign
				}
			} else if (currencyToConvertTo === 'kes') {
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertFrom) {
						amountToConvert = Number(amountToConvert) * Number(currency.sell_amount)
					}
				})
				return {
					amount: Math.round(amountToConvert),
					raw_amount: amountToConvert,
					sign: 'KES'
				}
			} else {
				var amount = 0
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertFrom) {
						amount = Number(amountToConvert) * Number(currency.sell_amount)
					}
				})
				allExchanges.find(function (currency) {
					if (currency.currency.toLowerCase() === currencyToConvertTo) {
						amount = Number(amount) / Number(currency.buy_amount)
						sign = currency.sign
					}
				})
				return {
					amount: Math.round(amount),
					raw_amount: amount,
					sign: sign
				}
			}
		},
		convertBasedBookingCreationDate: function (currencyToConvertFrom, amountToConvert, buyingRate, sellingRate) {
			if (currencyToConvertFrom === undefined || amountToConvert === undefined) {
				return {
					amount: 0,
					raw_amount: 0,
					sign: ''
				}
			}
			if (currencyToConvertFrom === undefined) {
				currencyToConvertFrom = 'KES'
			}
			if (amountToConvert === undefined) {
				amountToConvert = 0
			}
			var currencyToConvertTo = this.$store.state.CurrencyStore.browser_currency.toLowerCase()
			var allExchanges = this.$store.state.CurrencyStore.exchanges
			currencyToConvertFrom = currencyToConvertFrom.toLowerCase()
			var sign = ''
			let value = 0
			if (currencyToConvertFrom === currencyToConvertTo) {
				if (currencyToConvertFrom === 'kes') {
					sign = 'KES'
				} else {
					allExchanges.find(function (currency) {
						if (currency.currency.toLowerCase() === currencyToConvertTo) {
							sign = currency.sign
						}
					})
				}
				return {
					amount: amountToConvert,
					raw_amount: amountToConvert,
					sign: sign
				}
			} else {

				if (currencyToConvertFrom == 'usd') {
					value = amountToConvert * sellingRate
				} else {
					// var buyingExchangeRate = this.$store.state.CurrencyStore.currency_rate_by_date
					if (currencyToConvertTo == "usd" && currencyToConvertFrom == 'kes') {
						let currency_to = "6bf74e49-7ff6-4555-a080-15541d62204a";

						let data = {
							currency_id: currency_to,
							date: this.$moment(this.singleBooking.created_at).format("YYYY-MM-DD")
						};
						this.$store.dispatch("get_currency_exchange_rate_by_date", data);
					}
					var buyingExchangeRate = this.$store.state.CurrencyStore.currency_rate_by_date
					if (buyingExchangeRate.length > 0) {
						let exchangeRate = buyingExchangeRate[0]
						value = amountToConvert / exchangeRate.buy_amount
					}
				}
				return {
					amount: value,
					raw_amount: amountToConvert,
					sign: sign
				}
			}
		},


	}
}
